module.exports = __webpack_public_path__ + "media/images/logo-inline-20be513d585f58ba9ee6f8592e159e7f.svg";